module.exports = __webpack_public_path__ + "img/note8.0402e8f7.jpg";